import { useAtom } from 'jotai'
import { ActionIcon, Popover, SegmentedControl, Stack, Text } from '@mantine/core'
import { IconTextSize } from '@tabler/icons-react'
import { gameSettingsAtom } from '../../atoms/playerAtoms'

/**
 * In-session text-size control (Small / Medium / Large). Writes
 * gameSettingsAtom.fontSize, which the theme resolver maps to --bw-content-scale
 * (0.9 / 1 / 1.2), scaling every content surface via .markdown-content.
 *
 * Rendered as a compact ActionIcon popover so it fits the 40px action-bar
 * column without crowding the main Next/Submit button.
 */
export function TextSizeControl() {
  const [settings, setSettings] = useAtom(gameSettingsAtom)
  const value = settings.fontSize || 'medium'

  const setFontSize = (fontSize) => setSettings((s) => ({ ...s, fontSize }))

  return (
    <Popover position="top-end" withArrow shadow="md">
      <Popover.Target>
        <ActionIcon
          variant="subtle"
          color="cyan"
          size="md"
          aria-label="Text size"
          style={{ opacity: 0.7 }}
        >
          <IconTextSize size={18} />
        </ActionIcon>
      </Popover.Target>
      <Popover.Dropdown p="xs">
        <Stack gap={6}>
          <Text size="xs" c="dimmed" ta="center">
            Text size
          </Text>
          <SegmentedControl
            size="xs"
            color="cyan"
            value={value}
            onChange={setFontSize}
            data={[
              { label: 'S', value: 'small' },
              { label: 'M', value: 'medium' },
              { label: 'L', value: 'large' },
            ]}
          />
        </Stack>
      </Popover.Dropdown>
    </Popover>
  )
}
